export const DiscountBadge = ({ discount, currency }) => {
    if (!discount) return null;

    const label = discount.discountType === "percentage"
        ? `-${discount.discountValue}%`
        : `-${discount.discountValue} ${currency}`;

    return <span className="discount-badge">{label}</span>;
};

export default DiscountBadge;